import { Link, useLocation } from 'react-router-dom'
import { Auth } from 'aws-amplify'
import { NavMenus } from '../constants/Enum'
import UserContext from '../contexts/UserContext';
import { useContext, useState, Fragment } from 'react'
import ServiceWorkerLayout from './ServiceWorker'
import CheckLatestVersion from '../pages/Dialogs/CheckLatestVersion'
import NavBar from '../components/NavBar'
import NavBarBottom from '../components/NavBarBottom'
import { groupBy } from 'lodash'
import { Menu, Transition } from '@headlessui/react'
import { MdArrowDropDown } from 'react-icons/md'

import { Permission } from '../constants/Permission';
import { OrderType } from '../constants/EnumType';

function HeaderLayout() {
  const { user } = useContext(UserContext)

  const permissions = Permission[user.department][user.line || OrderType.All][user.role.toUpperCase()]

  const location = useLocation()

  const signOutAsync = async () => {
    try {
      if (!navigator.onLine) {
        return alert('ไม่สามารถออกจากระบบได้ในขณะไม่เชื่อม Wi-Fi')
      }
      await Auth.signOut();
      window.localStorage.removeItem('userInfo')
      window.location.pathname = '/'
    } catch (error) {
      console.log('error signing out: ', error);
    }
  }
  const [showCheckVersion, setShowCheckVersion] = useState(false)
  
  const groupByCatMenus = groupBy(NavMenus.filter(menu => menu.active), 'category')

  const isAdminGroup = user.group === 'Admins' && !permissions.includes('users')
  
  return <>
    <NavBar
      username={user?.name || user?.givenName || user?.username || ''}
      role={user?.role || user?.group || ''}
      allRoles={user?.allRoles}
      onSignout={signOutAsync}
      onCheckNewVersion={() => setShowCheckVersion(true)}
    >
      {permissions.map(path => {
        if (!groupByCatMenus.hasOwnProperty(path)) return null
        const menus = groupByCatMenus[path]
        if (menus.length > 1) {
          // multi menu
          return <Menu as="div" className="relative inline-block text-left" key={menus[0].title}>
             <div>
              <Menu.Button
                className={`block mt-4 md:flex items-center md:mt-0 hover:text-white mr-4 text-gray-400`}>
                {menus[0].categoryTitle || menus[0].title}
                <MdArrowDropDown size={20}/>
              </Menu.Button>
            </div>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items className="absolute right-0 z-10 w-48 mt-2 origin-top-right bg-white divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black/5 focus:outline-none">
                <div className="px-1 py-1 ">
                  {menus.map(m => <Menu.Item key={m.path}>
                    {() => (
                      <Link as={Link} to={`/${m.path}`} key={m.path}
                        className={`flex p-2 hover:bg-gray-300 hover:font-bold items-center gap-3`}>
                        {<m.logo size={20} className={m.color} />}{m.title}
                      </Link>
                    )}
                  </Menu.Item>)}
                </div>
              </Menu.Items>
            </Transition>
          </Menu>
        } else {
          const menu = menus[0]
          return <Link as={Link} to={`/${menu.path}`} key={menu.title}
            className={`block mt-4 md:inline-block md:mt-0 ${location.pathname.includes(menu.path) ? 'text-white' : 'text-gray-400'} hover:text-white mr-4`}>
            {menu.title}
          </Link>
        }
        
      })}
      {isAdminGroup ? <Link as={Link} to="/users"
        className={`block mt-4 md:inline-block md:mt-0 ${location.pathname.includes('users') ? 'text-white' : 'text-gray-400'} hover:text-white mr-4`}>
        จัดการผู้ใช้งาน
      </Link>: null}
    </NavBar>
    <NavBarBottom displayLeft={`${process.env.REACT_APP_ENV.toLowerCase()}:5a2a22c`}/>
    <ServiceWorkerLayout />
    {showCheckVersion ? 
    <CheckLatestVersion 
      show={showCheckVersion} 
      handleClose={() => setShowCheckVersion(false)}
    /> : null}
  </>
}

export default HeaderLayout;